import React, {useState} from 'react';
import {useMutation, useQuery} from '@apollo/client';
import {DialogProps} from 'packages/common-types/base-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';
import {User} from 'packages/common-types/schema-types';
import {ADD_TO_CLUB} from 'packages/graphql/v2/mutations';
import {GET_CLUBS, GET_USERS} from 'packages/graphql/v2/queries';
import {GetClubsData} from 'packages/common-types/queries-types';
import Swal from 'sweetalert2';
import {Button, FormControl, InputLabel, MenuItem} from '@material-ui/core';
import Select from '@material-ui/core/Select';

type Props = DialogProps & {
  uid: string;
};

type MutVars = {
  uid: string;
  clubId: string;
};

type MutData = {
  user: User;
};

const AddToClub = (props: Props) => {
  const {modalOpen, toggle, uid} = props;
  const [addToClub, {loading}] = useMutation<MutData, MutVars>(ADD_TO_CLUB);
  const {data} = useQuery<GetClubsData>(GET_CLUBS);
  const [clubId, setClubId] = useState('');

  const handleAddToClub = async () => {
    try {
      await addToClub({
        variables: {uid, clubId},
        refetchQueries: [
          {
            query: GET_USERS,
          },
        ],
      });
      Swal.fire({
        title: 'Hecho!',
        text: 'Usuario agregado al club.',
        icon: 'success',
      });
      toggle();
    } catch (error) {
      console.error('ERROR => ', error);
      Swal.fire({
        title: 'Error',
        text: 'No se pudo agregar al usuario al club.',
        icon: 'error',
      });
      toggle();
    }
  };

  const handleOnChange = (event: React.ChangeEvent<{value: any}>) => {
    setClubId(String(event.target.value));
  };
  const clubs = data?.getClubs;

  return (
    <>
      <Dialog
        open={modalOpen}
        onClose={toggle}
        aria-labelledby="dialog-select-club"
      >
        <DialogTitle>Añadir usuario a un club</DialogTitle>
        {loading && <LinearProgress />}
        <DialogContent>
          <DialogContentText>
            Selecciona un club de la lista y presiona agregar.
          </DialogContentText>
          {clubs && (
            <FormControl margin="dense" variant="outlined" fullWidth>
              <InputLabel id="select-club">Selecciona un club</InputLabel>
              <Select
                defaultValue=""
                label="Seleccione un club"
                value={clubId}
                onChange={handleOnChange}
              >
                <MenuItem disabled value="">
                  <em>Selecciona un club de la lista</em>
                </MenuItem>
                {clubs.map(({_id, name}) => {
                  return (
                    <MenuItem key={_id} value={_id}>
                      {name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={toggle} color="default">
            Cancelar
          </Button>
          <Button onClick={handleAddToClub} color="primary">
            Agregar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddToClub;
